module.exports = __webpack_public_path__ + "img/干果4.8eb31c57.png";